export default __webpack_public_path__ + "0014c4b705a07ef3dbfbd93b0c72f8e1.png";